import React from 'react';

import Meta from './../components/Meta';
import useMetaTags from './../hooks/useMetaTags';

import Header from './../components/header';
import Footer from './../components/footer';

function Terms() {
  useMetaTags();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>
        <p className="mb-6"><strong>Effective Date:</strong> March 19, 2025</p>

        {/* Section 1 */}
        <h2 className="text-xl font-bold mt-8 mb-4">1. Introduction</h2>
        <p>
          Welcome to <strong>AuLedger</strong>. These Terms of Service ("Terms") govern your use of the
          AuLedger mobile application ("App"). By downloading, installing, or using the App, you agree to
          be bound by these Terms.
        </p>

        {/* Section 2 */}
        <h2 className="text-xl font-bold mt-8 mb-4">2. Acceptance of Terms</h2>
        <p>
          By accessing or using our App, you confirm that you accept these Terms and agree to comply
          with them. If you do not agree with these Terms, you must not use our App.
        </p>

        {/* Section 3 */}
        <h2 className="text-xl font-bold mt-8 mb-4">3. Age Requirements</h2>
        <p>
          The App is intended for users of all ages and is rated 4+. However, if you are under the age of 18,
          you should review these Terms with a parent or guardian to ensure you understand them.
        </p>

        {/* Section 4 */}
        <h2 className="text-xl font-bold mt-8 mb-4">4. App Description and Features</h2>
        <p>The App allows users to:</p>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Track their physical gold items and collection.</li>
          <li>Monitor real-time gold prices.</li>
          <li>Calculate the current value of gold items.</li>
          <li>View historical gold price charts.</li>
          <li>Store photos and details of gold items.</li>
        </ul>

        <p>Our App offers both free and premium features:</p>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Free: Basic gold tracking with advertisements.</li>
          <li>Premium: Ad-free experience with multi-currency support and enhanced price charts.</li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-xl font-bold mt-8 mb-4">5. Account and User Data</h2>
        <h3 className="text-lg font-semibold mt-6 mb-2">5.1 No Account Required</h3>
        <p>AuLedger does not require you to create an account to use the App.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">5.2 Local Data Storage</h3>
        <p>All user data is stored locally on your device. We do not store data on our servers.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">5.3 Data Deletion</h3>
        <p>Deleting the App removes all associated data from your device.</p>

        {/* Section 6 */}
        <h2 className="text-xl font-bold mt-8 mb-4">6. Purchases and Payment</h2>
        <h3 className="text-lg font-semibold mt-6 mb-2">6.1 In-App Purchases</h3>
        <p>The App offers in-app purchases, including a subscription option.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">6.2 Payment Processing</h3>
        <p>All payments are processed via Apple App Store.</p>

        <h3 className="text-lg font-semibold mt-6 mb-2">6.3 Subscription Terms</h3>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Subscription renews automatically unless turned off at least 24 hours before the renewal date.</li>
          <li>Auto-renewal can be managed in Account Settings.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-6 mb-2">6.4 Refunds</h3>
        <p>Refund requests must be handled via Apple.</p>

        {/* Section 7 */}
        <h2 className="text-xl font-bold mt-8 mb-4">7. User Conduct</h2>
        <ul className="list-disc pl-6 mb-6 space-y-2">
          <li>Do not use the App for unlawful purposes.</li>
          <li>Do not reverse engineer or tamper with the App.</li>
        </ul>

        {/* Section 8 */}
        <h2 className="text-xl font-bold mt-8 mb-4">8. Intellectual Property Rights</h2>
        <p>The AuLedger logo, content, and trademarks are owned by AuLedger and protected by law.</p>

        {/* Section 9 */}
        <h2 className="text-xl font-bold mt-8 mb-4">9. Advertisements</h2>
        <p>Ads are provided by third-party networks. Premium users do not see ads.</p>

        {/* Section 10 */}
        <h2 className="text-xl font-bold mt-8 mb-4">10. Limitation of Liability</h2>
        <p>We are not responsible for any losses related to using the App.</p>

        {/* Section 11 */}
        <h2 className="text-xl font-bold mt-8 mb-4">11. Changes to the Terms</h2>
        <p>We may update these Terms at any time.</p>

        {/* Section 12 */}
        <h2 className="text-xl font-bold mt-8 mb-4">12. Contact</h2>
        <p>
          For any questions, contact us at:{" "}
          <a href="mailto:contact@auledgerapp.com" className="text-blue-600 hover:underline">
            contact@auledgerapp.com
          </a>
        </p>

        {/* Last Updated */}
        <p className="mt-10 mb-6"><em>Last Updated: March 19, 2025</em></p>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
